module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header header4"
  }, [_c('div', {
    staticClass: "header-main"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "clear1"
  }), _vm._v(" "), _c('div', {
    staticClass: "header-right"
  }, [_c('button', {
    staticClass: "header-but1",
    attrs: {
      "id": "header-but1"
    },
    on: {
      "click": function($event) {
        _vm.$router.push('newyearactivityrule')
      }
    }
  }, [_vm._v("活动详情\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "header-footer"
  }, [_vm._v("新用户*赢现金红包，推广人得现金奖励")])])]), _vm._v(" "), _c('div', {
    staticClass: "main1"
  }, [_c('div', {
    staticClass: "rc"
  }, [_c('div', {
    staticClass: "c1",
    on: {
      "click": _vm.ref
    }
  }, [_vm._v("推广新人")])]), _vm._v(" "), _c('div', {
    staticClass: "rc"
  }, [_c('div', {
    staticClass: "c2",
    on: {
      "click": _vm.playForm
    }
  }, [_vm._v("参与活动")])])]), _vm._v(" "), _c('div', {
    staticClass: "clear1"
  }), _vm._v(" "), _c('div', {
    staticClass: "main1"
  }, [_c('div', {
    staticClass: "rc"
  }, [_c('div', {
    staticClass: "c3",
    on: {
      "click": function($event) {
        _vm.$router.push('/newyearactivitymypackage')
      }
    }
  }, [_vm._v("我的红包")])]), _vm._v(" "), _c('div', {
    staticClass: "rc"
  }, [_c('div', {
    staticClass: "c4",
    on: {
      "click": function($event) {
        _vm.$router.push('/shop')
      }
    }
  }, [_vm._v("查看商城")])])]), _vm._v(" "), _c('div', {
    staticClass: "clear1"
  }), _vm._v(" "), _c('div', {
    staticClass: "footer4"
  }, [_vm._v("*新用户：新关注或未购买过产品的用户。")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-left"
  }, [_c('p', {
    staticStyle: {
      "margin-top": "15px",
      "color": "#000"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "#09bb07"
    }
  }, [_vm._v("有奖 ")]), _vm._v("传播生态护眼的爱心")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "15px",
      "color": "#000"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "#09bb07"
    }
  }, [_vm._v("免费 ")]), _vm._v("体验改变视界的感受")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-787dcf78"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/newYearActivity/Index.vue
// module id = 720
// module chunks = 0